var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StoryblokPage',{attrs:{"sb-fetch-params":{ resolve_relations: 'bottom_layout' }},scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(ref){
var blok = ref.blok;
return [(blok)?_c('PageBreadcrumbV2',{attrs:{"items":_vm.getBreadcrumbs(blok),"show-home":false}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }